import React from 'react';
import styled, { css } from 'styled-components';
import { brandColours, minBreakpointQuery, sectionPaddings } from '../styles';
import { Button, Container, Heading, HtmlContent } from './ui';

const StyledCallToActionStrip = styled.section`
  ${sectionPaddings('45px', '90px')};
  background-color: ${brandColours.primary};
  position: relative;
`;

const StyledInner = styled.div`
  display: grid;
  gap: 30px;

  ${minBreakpointQuery.tiny`
    gap: 40px;
  `}

  ${minBreakpointQuery.small`
    gap: 50px;
  `}

  ${({ imageAbove }) => {
    if (imageAbove) {
      return css`
        ${minBreakpointQuery.smedium`
          margin: 0 auto;
          padding-top: 80px;
          max-width: 680px;
        `}
      `;
    } else {
      return css`
        ${minBreakpointQuery.smedium`
          grid-template-columns: repeat(2, 1fr);
          align-items: center;
        `};

        ${minBreakpointQuery.medium`
          gap: 70px;
        `}

        ${minBreakpointQuery.large`
          gap: 90px;
        `}

        ${minBreakpointQuery.xxlarge`
          gap: 120px;
        `}
      `;
    }
  }}
`;

const StyledImage = styled.img`
  margin: auto;
  height: 100%;
  width: 100%;

  ${({ imageAbove }) => {
    if (imageAbove) {
      return css`
        max-height: 150px;
        max-width: 650px;

        ${minBreakpointQuery.smedium`
          position: absolute;
          top: -30px;
          left: 50%;
          transform: translateX(-50%);
        `}
      `;
    } else {
      return css`
        max-height: 400px;
        max-width: 400px;

        ${minBreakpointQuery.smedium`
          grid-column-start: 2;
          grid-row-start: 1;
        `}
      `;
    }
  }}
`;

const StyledContent = styled.div`
  text-align: ${({ imageAbove }) => (imageAbove ? 'center' : 'left')};
`;

const StyledHeading = styled(Heading)`
  line-height: 1.4;
`;

const StyledText = styled(HtmlContent)`
  margin-top: 15px;
`;

const StyledButton = styled(Button)`
  margin-top: 20px;
  width: 100%;

  ${({ imageAbove }) => {
    if (imageAbove) {
      return css`
        ${minBreakpointQuery.smedium`
          max-width: 360px;
        `}
      `;
    } else {
      return css`
        ${minBreakpointQuery.smedium`
          max-width: 220px;
        `}
      `;
    }
  }}
`;

const CallToActionStrip = ({ image, heading, content, link, imageAbove }) => (
  <StyledCallToActionStrip>
    <Container>
      <StyledInner imageAbove={imageAbove}>
        <StyledImage
          src={image.url}
          alt={image.alt}
          loading="lazy"
          imageAbove={imageAbove}
        />
        <StyledContent imageAbove={imageAbove}>
          <StyledHeading>{heading}</StyledHeading>
          <StyledText content={content} />
          <StyledButton to={link.pageUrl} imageAbove={imageAbove}>
            {link.text}
          </StyledButton>
        </StyledContent>
      </StyledInner>
    </Container>
  </StyledCallToActionStrip>
);

export default CallToActionStrip;
